<!-- 
  航空航线 航线标签
 -->

<template>
  <div class="w468 routeLabelMaxBox">
    <div class="header safety_heard" v-interact>
      <div class="toubu">
        <div class="hd-box">航线标签</div>
      </div>
      <div class="right">
        <div class="fontOne cp" @click="$emit('close')">
          <img src="@/assets/img/i40.png" alt="" class="img">
        </div>
      </div>
    </div>
    <div class="nei">
      <div class="routeLabelTop jcsb">
        <div class="routeLabelCreate" @click="showLabel">创建标签</div>
        <div class="jcsb" v-if="createFlag">
          <el-input clearable size="mini" maxlength="6" v-model="labelValue" placeholder="请输入标签名称"></el-input>
          <div class="routeLabelCreate btn_an" @click="createFn">保存</div>
        </div>
      </div>
      <div class="routeLabelSearch jcsb">
        <el-input class="route-search" size="mini" placeholder="请输入标签名称" suffix-icon="el-icon-search" v-model="search">
        </el-input>
        <div class="preservation" @click="searchBtn">
          搜索
        </div>
      </div>
      <div class="routeLabelList pt20 pl20 mt20 h321">
        <div class="h300 routeLabelListBox">
          <div class="routeLabelListItem mb10" v-for="(item, index) in listData" :key="index">
            <el-checkbox v-model="item.status">{{ item.labelName }}
            </el-checkbox>
            <span @click="delBtn(item.id)" class="cp mr20 fr iconfont  icon-baseshanchu1" style="#00a9ff"></span>
          </div>
        </div>
      </div>
      <div class="jcsb mt20 jcsb-new">

        <div class="preservation" @click="$emit('close')">
          取消
        </div>
        <div class="preservation preservation-save" @click="handClickFn">
          保存
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data () {
    return {
      createFlag: false,
      labelValue: '',
      search: null,
      checked: '',
      listData: [],
    }
  },
  props: ['id'],
  watch: {
    id (newValue) {
      this.listFn()
    },
  },
  created () {
    this.listFn()
  },
  methods: {
    searchBtn () {
      this.listFn()
    },
    async handClickFn () {
      let newArr = []
      this.listData.forEach((element) => {
        if (element.status) {
          newArr.push(element.id)
        }
      })

      let res = await API.AIRWAY.updatatag({
        flightId: this.id,
        labelIds: newArr,
      })
      this.$message.success('创建成功')
      this.$emit('close')
      this.$emit('changeList')
    },
    async selectList () {
      let res = await API.AIRWAY.getLabelById({ id: this.id })
      let listData = JSON.parse(JSON.stringify(this.listData))
      for (let i = 0; i < res.length; i++) {
        for (let j = 0; j < listData.length; j++) {
          if (listData[j].id == res[i].labelId) {
            listData[j].status = true
          }
        }
      }
      this.listData = listData
    },
    async listFn () {
      let res = await API.AIRWAY.getFlightLineLabel({ labelName: this.search })
      if (res) {
        let newArr = []
        res.forEach((element) => {
          newArr.push({
            id: element.id,
            labelName: element.labelName,
            status: false,
          })
        })
        this.listData = newArr
        this.selectList()
      }
    },
    showLabel () {
      if (!this.createFlag) {
        this.labelValue = ''
        this.createFlag = true
      }
    },
    async createFn () {
      if (this.labelValue == '') {
        return this.$message.info('标签名称不能为空')
      } else {
        let res = await API.AIRWAY.insert({
          labelName: this.labelValue,
        })
        if (res.status == 1) {
          this.$message.success('创建成功')
          this.labelValue = ''
          this.createFlag = false
          this.listFn()
        } else {
          this.$message.error(res.message)
        }
      }
    },
    //
    async delBtn (id) {
      let res = await API.AIRWAY.update({
        id,
        lableStatus: 1,
      })
      if (res.status == 1) {
        this.listFn()
      }
    },
  },
}
</script>

<style lang='scss'  scoped>
::v-deep.el-input--mini {
  .el-input__inner {
    height: 32px;
    color: #ffffff;
  }
}

::v-deep.el-checkbox {
  color: #fff;
}

.routeLabelMaxBox {
  position: absolute;
  left: 50%;
  background-color: #0A293A;

  .route-search::placeholder {
    color: #fff;
  }

  .routeLabelTop {
    display: flex;
    justify-content: space-between;

    .routeLabelCreate {
      width: 92px;
      height: 32px;
      line-height: 32px;
      // background-image: url('~@/assets/yingkong1027/btn_lan.png');
      background-size: 100% 100%;
      text-align: center;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      cursor: pointer;
      margin: 0 14px 0 0;
      background-color: #4E87AC;
      border-radius: 4px;
    }
  }

  .routeLabelList {
    background: rgba(2, 31, 51, 0.7);
    border: 1px solid rgba(0, 159, 255, 0.6);
    box-shadow: 0 2px 4px 0 rgba(1, 162, 255, 0.35);

    border-radius: 13px;

    .routeLabelListBox {
      overflow-y: auto;
      color: #fff;
    }
  }

  .routeLabelBottom {
    display: flex;
    justify-content: space-around;
  }

  .preservation {
    // background: rgba(0, 34, 140, 0.2);
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), inset 0 0 15px 0 #00b6ff;
    // border-radius: 6px;
    color: #ffffff;
    // width: 92px;
    width: 64px !important;
    height: 32px;
    line-height: 32px;
    // background-image: url('~@/assets/yingkong1027/btn_lan.png');
    background-size: 100% 100%;
    text-align: center;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    cursor: pointer;
    // margin: 0 14px 0 0;
    background-color: #4E87AC;
    border-radius: 4px;
  }

  .preservation-save {
    margin-left: 10px;
  }

  .el-input {
    background: rgba(2, 31, 51, 0.7);
    border-radius: 6px;
  }

  .el-input__inner {
    background: rgba(2, 31, 51, 0.7);
    border: 1px solid rgba(6, 182, 224, 0.7);
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  background-color: #224D68;
  box-sizing: border-box;
  padding: 5px 10px 5px 10px;

  .toubu {
    display: flex;

    .hd-box {
      font-size: 18px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
    }
  }

  .right {
    color: #ffffff;

    .img {
      width: 22px;
      height: 22px;
      cursor: pointer;
    }
  }
}

.nei {
  box-sizing: border-box;
  padding: 12px 12px 16px 12px;
}

.el-input--suffix {
  width: 262px;
  height: 32px;
  background: #02173d;
  border-radius: 2px;
  border: 1px solid #315ec7;

  .el-input__inner {
    border: 0px solid transparent;
  }
}

.btn_an {
  width: 64px !important;
  height: 32px !important;
  margin: 0 0 0 14px !important;
}

.routeLabelSearch {
  margin: 12px 0 0 0;
}

.jcsb-new {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>